import { createFeature } from '@ngrx/store';
import { FeatureKey } from '../constants';
import { gridViewsReducer } from '../reducers';

export const GRID_VIEW_FEATURE_STATE = createFeature({
  name: FeatureKey,
  reducer: gridViewsReducer,
});
